// Route Code Edited 06/30/2026
/**
 * YMQ + Route: move Route checkout UI out of YMQ click spans and enable pointer events.
 * Supports YMQ cart drawer (.ymq-cart-app-*) and cart page (.cart__ctas).
 */
(function () {
  'use strict';

  var CONTAINERS = '.ymq-cart-app-checkout-buttons, .cart__ctas';
  var CHECKOUT =
    '.ymq-cart-app-checkout-button, .ymq-cart-app-button[name="checkout"], button.cart__checkout-button[name="checkout"], #checkout[name="checkout"]';
  var ROUTE_UI = '[data-route-widget-button], [data-route-widget]';
  var ROUTE_CLONE = '[data-route-cloned-button]';
  var ROUTE_PRESENT =
    '[data-route-widget-button], [data-route-cloned-button], [data-protection-widget]';
  var YMQ_MARKERS =
    '.ymq-cart-app-checkout-buttons, .ymq-cart-app-checkout-button, .ymq-cart-app-button[name="checkout"]';

  var applying = false;
  var rafId = 0;

  function routeActive() {
    return !!(window.Route || document.querySelector(ROUTE_PRESENT));
  }

  function ymqActive() {
    if (document.querySelector(YMQ_MARKERS)) return true;
    var cart = document.querySelector('.cart__ctas');
    return !!(cart && cart.querySelector(ROUTE_UI) && cart.querySelector(CHECKOUT));
  }

  function shouldRun() {
    return routeActive() && ymqActive();
  }

  function getContainers() {
    return Array.prototype.slice.call(document.querySelectorAll(CONTAINERS));
  }

  function isYmqSpan(span) {
    if (!(span instanceof HTMLElement) || span.tagName !== 'SPAN') return false;
    return span.style.getPropertyValue('cursor') === 'pointer';
  }

  function checkoutDelegationSpan(container, checkoutButton) {
    if (!(checkoutButton instanceof HTMLElement)) return null;
    var node = checkoutButton.parentElement;
    while (node && node !== container) {
      if (isYmqSpan(node)) return node;
      node = node.parentElement;
    }
    return null;
  }

  function containerNeedsFix(container) {
    var routeUi = container.querySelector(ROUTE_UI);
    if (!routeUi) return false;

    var checkout = container.querySelector(CHECKOUT);
    var span = checkoutDelegationSpan(container, checkout || routeUi);
    if (span && span.contains(routeUi)) return true;

    var clone = container.querySelector(ROUTE_CLONE);
    if (!(clone instanceof HTMLElement)) return false;
    if (clone.getAttribute('name') === 'checkout') return true;
    return clone.style.getPropertyValue('pointer-events') === 'none';
  }

  function enableClicks(el) {
    if (!(el instanceof HTMLElement)) return;
    if (el.style.getPropertyValue('pointer-events') !== 'none') return;
    el.style.setProperty('pointer-events', 'auto');
  }

  function stripRouteCheckoutName(button) {
    if (!(button instanceof HTMLElement)) return;
    if (button.getAttribute('name') === 'checkout') {
      button.removeAttribute('name');
    }
  }

  function cleanupEmptyYmqSpans(container) {
    Array.prototype.slice.call(container.querySelectorAll('span')).forEach(function (span) {
      if (!isYmqSpan(span)) return;
      if (span.childElementCount === 0 && !span.textContent.trim()) {
        span.remove();
      }
    });
  }

  function fixContainer(container) {
    if (!(container instanceof HTMLElement)) return;

    container.querySelectorAll(ROUTE_CLONE).forEach(stripRouteCheckoutName);

    if (containerNeedsFix(container)) {
      var checkout = container.querySelector(CHECKOUT);
      var routeUi = container.querySelector(ROUTE_UI);
      var span = checkoutDelegationSpan(container, checkout || routeUi);

      if (span && routeUi && span.contains(routeUi)) {
        if (span.nextSibling) container.insertBefore(routeUi, span.nextSibling);
        else container.appendChild(routeUi);
      }

      container.querySelectorAll(ROUTE_CLONE).forEach(function (clone) {
        enableClicks(clone);
        stripRouteCheckoutName(clone);
      });
    }

    cleanupEmptyYmqSpans(container);
  }

  function applyFix() {
    if (applying || !shouldRun()) return;
    applying = true;
    try {
      getContainers().forEach(fixContainer);
    } finally {
      applying = false;
    }
  }

  function scheduleFix() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = 0;
      applyFix();
    });
  }

  function init() {
    applyFix();

    new MutationObserver(function (mutations) {
      if (applying) return;
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'childList') {
          scheduleFix();
          return;
        }
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'name' &&
          mutation.target instanceof HTMLElement &&
          mutation.target.matches(ROUTE_CLONE) &&
          mutation.target.getAttribute('name') === 'checkout'
        ) {
          scheduleFix();
          return;
        }
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['name'],
    });

    ['cart:change', 'cart:refresh', 'cart-drawer:refreshed'].forEach(function (name) {
      document.addEventListener(name, applyFix, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// End Route Code